module.exports = __webpack_public_path__ + "media/images/banner/tcvb/tcvb-zh-hant-e9b544a18f25700f3ebe07b975d72f7b.jpg";